export default {
	data: {
		selectedImageIndex: undefined
	},
	beforeMount: function () {
		//console.warn("ha", window.location.search);
		var url = new URL(window.location.href);
		var params = {};
		for (let key of url.searchParams.keys()) {
			//console.log("p", key, url.searchParams.get(key));
			params[key] = url.searchParams.get(key);

		}
		this.searchParams = params;
	},
	/*mounted: function () {
		console.log('updated from dummy.....');
		const faqItems = document.querySelectorAll('.faq-item');
		faqItems.forEach(item => {
			item.querySelector('.faq-question').addEventListener('click', () => {
				console.log('item clicked...');
				item.classList.toggle('active');
			});
		});
	},*/
	computed: {

		mailto: function () {
			return `mailto:${this.emailAddress}`;
		},
		emailAddress: function () {
			return (VOFFICE.contactEmail || ['info', 'test.de']).join('@');
		}
	}

};